export default __webpack_public_path__ + "static/media/tqicon-2.cdf87047.svg";